export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBbHI_M52hzJmhjxWX9-_-VdM3AA5Ttxbw",
    authDomain: "yukthatag.firebaseapp.com",
    projectId: "yukthatag",
    storageBucket: "yukthatag.firebasestorage.app",
    messagingSenderId: "265520585855",
    appId: "1:265520585855:web:7cde42aad71763bd64b34a",
    measurementId: "G-W8ZV3B67M1"
  }
};
